/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Images from '../img/ImagePaths';

// defines the BMWLogo props ...
export type BMWLogoProps = {
  width?: number;
  height?: number;
};

/**
 * Defines the default Corporate BMWLogo Component.
 *
 * ```typescript
 *   import BMWLogo from '@ion/dls/src/logo';
 *
 *   <BMWLogo />
 *
 * ```
 */
const BMWLogo = ({width = 160, height = 50}: BMWLogoProps) => (
  <img src={Images.BMWPoweredBy} style={{width, height}}/>
);
export default BMWLogo;
